import { ABMEnrollmentStatusEnum } from '@electricjs/core_entity-client';

import ABMConnectedMessage from '@/components/ABMManagement/ABMConnectedMessage';
import ABMUnconnectedBanner from '@/components/ABMManagement/ABMUnconnectedBanner';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { useGetOrganizationAdditionalInfoQuery } from '@/redux/slices/organizationApiSlice';
import ABMUnknownBanner from '@/components/ABMManagement/ABMUnknownBanner';

type ABMStorefrontProps = {
  storeCountry?: string;
};

const ABMStorefront = ({ storeCountry }: ABMStorefrontProps) => {
  const organizationId = useGetOrganizationId();

  const {
    data: orgAdditionalInfoData,
    isFetching: isFetchingOrgAdditionalInfoData,
  } = useGetOrganizationAdditionalInfoQuery({ organizationId });

  // silent loading: don't show anything while loading, until we have an abm status available
  if (isFetchingOrgAdditionalInfoData) {
    return null;
  }

  switch (orgAdditionalInfoData?.abmStatus) {
    case ABMEnrollmentStatusEnum.Connected:
      return <ABMConnectedMessage storeCountry={storeCountry} />;
    case ABMEnrollmentStatusEnum.Unconnected:
      return <ABMUnconnectedBanner />;
    case ABMEnrollmentStatusEnum.NotApplied:
      return null;
    case ABMEnrollmentStatusEnum.Unknown:
    default:
      return <ABMUnknownBanner />;
  }
};

export default ABMStorefront;
